import { getMixpanelAuthenticated } from "./selectors.js";
import { actions, reducer, sliceKey } from "./slice.js";
import { AnalyticsEventName, TrackErrorParams, TrackEventParams, UseMixpanelReturnType } from "./types.js";
import { getUser } from "../../entities/User/hooks/useUserState/selectors.js";
import { useEffect } from "react";
import { useMixpanel } from "react-mixpanel-browser";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer } from "redux-injectors";

export const useInitMixpanel = () => {
    useInjectReducer({ key: sliceKey, reducer });
    const mixpanel = useMixpanel();
    const user = useSelector(getUser);
    const mixpanelAuthenticated = useSelector(getMixpanelAuthenticated);
    const dispatch = useDispatch();

    useEffect(() => {
        if (mixpanel?.config?.token && user?._id && !mixpanelAuthenticated) {
            mixpanel.identify(user?._id);
            dispatch(actions.setAuthenticated());
        }
    }, [user?._id, mixpanelAuthenticated]);
};

export const useMixpanelTrack = (): UseMixpanelReturnType => {
    useInjectReducer({ key: sliceKey, reducer });

    const mixpanel = useMixpanel();
    const mixpanelAuthenticated = useSelector(getMixpanelAuthenticated);

    const trackEvent = (params: TrackEventParams) => {
        const { eventName, properties } = params;
        if (mixpanel?.config?.token && mixpanelAuthenticated) {
            mixpanel.track(eventName, properties);
        }
    };

    const trackError = (params: TrackErrorParams) => {
        trackEvent({ eventName: AnalyticsEventName.ENCOUNTER_AN_ERROR, properties: params });
    };

    return { trackEvent, trackError };
};
